import { render, staticRenderFns } from "./ModalStockProductHistory.vue?vue&type=template&id=56b8ab1a&scoped=true"
import script from "./ModalStockProductHistory.vue?vue&type=script&lang=js"
export * from "./ModalStockProductHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalStockProductHistory.vue?vue&type=style&index=0&id=56b8ab1a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8ab1a",
  null
  
)

export default component.exports